module.exports = "app-top-items {\n  display: block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/side-menu/top-items/styles/top-items.scss
// module id = ./src/app/system/core/side-menu/top-items/styles/top-items.scss
// module chunks = main